__webpack_require__.hmrF = () => ("hotelfinder." + __webpack_require__.h() + ".hot-update.json");